import { writable } from 'svelte/store';

export const showplus = writable(true);
export const shownote = writable(false);
export const cancalAdd = writable(false);
export const title = writable('');
export const alertinfo = writable(false);
export const showheader = writable(true);